import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import FastRewindIcon from '@mui/icons-material/FastRewind';

import DashboardIcon from '@mui/icons-material/Dashboard'
import ForumIcon from '@mui/icons-material/Forum'
import HelpIcon from '@mui/icons-material/Help'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentIcon from '@mui/icons-material/Payment'
import User from '@mui/icons-material/Groups2';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'
import PermDataSettingIcon from '@mui/icons-material/PermDataSetting';
import { Box, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import LoadingUI from '../comman/LoadingUI'
import { ThemeContext } from '../context/ThemeProvider'
import Style from '../css/components/Drawer.module.scss'
import { getPermissionAndRoleAction } from '../redux/toolkit/dashbaord/getPermissionAndRole'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';


export default function DrawerUI() {
    // state---->
    const dispatch = useDispatch()
    const permission = useSelector(state => state.getPermissionAndRole)
    const { data: permissionData, loading: permissionLoading } = permission


    const { drawerSilde } = useContext(ThemeContext)
    const location = useLocation()?.pathname




    const handleSubDiv = () => {
        var div = document.getElementById("myDiv");
        if (div.style.display === "none") {
            div.style.display = "block";
        } else {
            div.style.display = "none";
        }
    }

    const drawerListDashboard = []

    if (permissionData?.permission?.includes("home") || permissionData?.role == 'super_admin') { drawerListDashboard.push({ name: "Dashboard", icon: <DashboardIcon fontSize='small' color={location == "/" ? "primary" : ''} />, path: '/' }) }
    if (permissionData?.permission?.includes("publisherDashboard") || permissionData?.role == 'super_admin') { drawerListDashboard.push({ name: "Publisher Dashboard", icon: <DashboardIcon fontSize='small' color={location == "/publisher-dashboard" ? "primary" : ''} />, path: '/publisher-dashboard' }) }

    if (permissionData?.permission?.includes("qns_and_ans") || permissionData?.role == 'super_admin') { drawerListDashboard.push({ name: "Profiler Question", icon: <HelpIcon fontSize='small' color={location == '/qns-ans' ? "primary" : ''} />, path: '/qns-ans' }) }

    if (permissionData?.permission?.includes("partner") || permissionData?.role == 'super_admin') { drawerListDashboard.push({ name: "Partner", icon: <LocalOfferIcon fontSize='small' color={location == '/partner' ? "primary" : ''} />, path: '/partner' }) }



    const adminList = [
        { name: "Admin", icon: <AdminPanelSettingsIcon fontSize='small' color={location == '/admin' ? "primary" : ''} />, path: '/admin',path2:['/admin'] },
        { name: "User", icon: <User fontSize='small' color={location == '/user' ? "primary" : ''} />, path: '/user',path2:['/user','/user-detail'] },
        { name: "Publisher User", icon: <User fontSize='small' color={location == '/publisher-user' ? "primary" : ''} />, path: '/publisher-user',path2:['/publisher-user','/user-transaction'] },
        { name: "Offers", icon: <LocalOfferIcon fontSize='small' color={location == '/offers' ? "primary" : ''} />, path: '/offers',path2:['/offers'] },
        { name: "User Offer Attempts", icon: <LocalOfferIcon fontSize='small' color={location == '/user-offer-attempts' ? "primary" : ''} />, path: '/user-offer-attempts',path2:['/user-offer-attempts'] },
        { name: "Admin Logs", icon: <SupervisorAccountIcon fontSize='small' color={location == '/admin-log' ? "primary" : ''} />, path: '/admin-log',path2:['/admin-log'] },
        { name: "Config", icon: <PermDataSettingIcon fontSize='small' color={location == '/config-meta' ? "primary" : ''} />, path: '/config-meta',path2:['config-meta'] },
        { name: "All Video", icon: <OndemandVideoIcon fontSize='small' color={location == '/all-video' ? "primary" : ''} />, path: '/all-video',path2:['/all-video'] },

    ]



    const publisherList = [] 
    if (permissionData?.permission?.includes("publisher") || permissionData?.role == 'super_admin') { publisherList.push({ name: "Publisher", icon: <ForumIcon fontSize='small' color={location == '/publisher' ? "primary" : ''} />, path: '/publisher' }) }
    if (permissionData?.permission?.includes("postback") || permissionData?.role == 'super_admin') { publisherList.push({ name: "Postback Logger", icon: <FastRewindIcon fontSize='small' color={location == '/post-back' ? "primary" : ''} />, path: '/post-back' }) }
    if (permissionData?.permission?.includes("chargeback") || permissionData?.role == 'super_admin') { publisherList.push({ name: "Charge Back", icon: <FastRewindIcon fontSize='small' color={location == '/charge-back' ? "primary" : ''} />, path: '/charge-back' }) }
    if (permissionData?.permission?.includes("pendingTransaction") || permissionData?.role == 'super_admin') { publisherList.push({ name: "PendingTransaction", icon: <AccountBalanceIcon fontSize='small' color={location == '/pendingTransaction' ? "primary" : ''} />, path: '/pendingTransaction' }) }
    if (permissionData?.permission?.includes("payments") || permissionData?.role == 'super_admin') { publisherList.push({ name: "Payments", icon: <PaymentIcon fontSize='small' color={location == '/payments' ? "primary" : ''} />, path: '/payments' }) }
    if (permissionData?.permission?.includes("bank") || permissionData?.role == 'super_admin') { publisherList.push({ name: "Bank Request", icon: <AccountBalanceIcon fontSize='small' color={location == '/bank' ? "primary" : ''} />, path: '/bank' }) }





    useEffect(() => {
        dispatch(getPermissionAndRoleAction())
    }, [dispatch, location])



    return (
        <Box className={drawerSilde ? Style.drawerOpen : Style.drawerClose}>

            <Box className={Style.header}>
                <p>Surveywall</p>

            </Box>

           
            <div style={{ border: "2px solid #E0E0E0", margin: "2px 15px" }}>
                {drawerListDashboard?.map((items, index) => {
                    return (
                        <div key={index}>
                            <Link to={items?.path} style={{ textDecoration: 'none' }}>
                                <ListItem disablePadding className={location == items?.path ? Style.actvie_link : Style.non_actvie_link}>
                                    <ListItemButton>
                                        <ListItemIcon className={location == items?.path ? Style.actvie_icon : Style.actvie_icon}>
                                            {items?.icon}
                                        </ListItemIcon>
                                        {drawerSilde && <ListItemText primary={items?.name} />}
                                    </ListItemButton>
                                </ListItem>
                            </Link>

                        </div>
                    )

                })}

                {permissionData?.role == 'super_admin' ?
                    <List disablePadding subheader={drawerSilde && <ListSubheader sx={{ fontSize: 17, }} component="div">Admin</ListSubheader>}>
                        {adminList?.map((items, index) => {
                            return (
                                <>
                                    {permissionLoading
                                        ? <LoadingUI />
                                        :
                                        <Link key={index} to={items?.path} style={{ textDecoration: 'none', }}>
                                            <ListItem disablePadding className={items?.path2?.includes(location) ? Style.actvie_link : Style.non_actvie_link}>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        {items?.icon}
                                                    </ListItemIcon>
                                                    {drawerSilde && <ListItemText primary={items?.name} />}
                                                </ListItemButton>
                                            </ListItem>
                                        </Link>
                                    }
                                </>
                            )
                        })}
                    </List>
                    : null
                }
                
                {publisherList?.length ?
                    <List disablePadding subheader={drawerSilde && <ListSubheader sx={{ fontSize: 17, }} component="div">Publisher</ListSubheader>}>
                        {publisherList?.map((items, index) => {
                            return (
                                <>
                                    {permissionLoading
                                        ? <LoadingUI />
                                        : <Link key={index} to={items?.path} style={{ textDecoration: 'none', }}>
                                            <ListItem disablePadding className={location == items?.path ? Style.actvie_link : Style.non_actvie_link}>
                                                <ListItemButton>
                                                    <ListItemIcon>
                                                        {items?.icon}
                                                    </ListItemIcon>
                                                    {drawerSilde && <ListItemText primary={items?.name} />}
                                                </ListItemButton>
                                            </ListItem>
                                        </Link>
                                    }

                                </>

                            )
                        })}
                    </List>
                    : null
                }

            </div>
        </Box >
    )
}

